module.exports = __webpack_public_path__ + "static/img/cont59 (1).cfe1a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (1).jpg
// module id = Z2hN
// module chunks = 0